import { PositionsList } from '@/pages/positions/list/PositionsList';

/** `/positions` — saved views (pipeline board, table, Go/No-go queue), filters, "New position". */
export function PositionsListPage() {
  return <PositionsList />;
}
